import React from 'react';
import '../../src/styles/terms.css';

const TermsPage: React.FC = () => {
  return (
    <div className="terms-root">
      <header className="terms-header">
        <div className="terms-brand"><a className="brand-link" href="/">Burst</a></div>
      </header>

      <main className="terms-main">
        <section className="terms-card" aria-labelledby="terms-heading">
          <h1 id="terms-heading">Terms of Service</h1>
          <p className="terms-updated">Last updated: 6th October 2025</p>

          <p className="terms-intro">
            Welcome to <strong>Burst Athletics</strong>. These Terms explain how you can use our
            website, app and services (the “Service”). By using the Service you agree to these Terms.
          </p>
          <p className="terms-intro">
            If you don’t agree, please don’t use the Service.
          </p>

          <ol className="terms-list">
            <li id="t1">
              <h2>Using Burst</h2>
              <p>You must be <strong>18+</strong> (or have a parent/guardian’s consent if younger).</p>
              <p>Keep your account details accurate and secure. You’re responsible for activity on your account.</p>
            </li>

            <li id="t2">
              <h2>Health &amp; safety (important but simple)</h2>
              <p>We share coaching for information only—it isn’t medical advice.</p>
              <p>
                Check with a healthcare professional before starting new training, especially if you have a condition,
                are pregnant, or take medication.
              </p>
              <p>
                Train sensibly: use suitable equipment, progress gradually, and stop if you feel unwell or in pain. You
                use the Service <strong>at your own risk</strong>.
              </p>
            </li>

            <li id="t3">
              <h2>Content &amp; your rights</h2>
              <p>
                We (and our partners) own the content in the Service (videos, text, graphics, software, brand). We give
                you a <strong>personal, non-commercial, revocable licence</strong> to use it.
              </p>
              <p>Please don’t copy, sell, modify, or reverse-engineer our content or software.</p>
            </li>

            <li id="t4">
              <h2>What’s not OK</h2>
              <p>
                Don’t upload anything illegal or harmful, don’t harass others, don’t try to break or scrape the
                Service, and don’t use it in unsafe situations (e.g., while driving).
              </p>
            </li>

            <li id="t5">
              <h2>Subscriptions &amp; billing (if applicable)</h2>
              <p>
                Prices and plan details are shown in-app/checkout. Trials roll into paid plans unless cancelled before
                the trial ends.
              </p>
              <p>
                Manage/cancel through your app store account or in-app where available. Payments already taken are
                non-refundable unless required by law.
              </p>
            </li>

            <li id="t6">
              <h2>Third-party services</h2>
              <p>
                We use trusted third parties (e.g., app stores, payments, analytics). Their terms and privacy practices
                apply to their services.
              </p>
            </li>

            <li id="t7">
              <h2>Disclaimers &amp; limits</h2>
              <p>
                We aim to keep the Service helpful and available, but it’s provided “as is”—we don’t promise specific
                results or uninterrupted access.
              </p>
              <p>
                To the extent the law allows, we’re not liable for indirect or consequential losses. Our total liability
                for any claim is limited to the amount you paid in the last 12 months or <strong>£50</strong>, whichever
                is higher.
              </p>
            </li>

            <li id="t8">
              <h2>Ending or changing the Service</h2>
              <p>
                You can stop using the Service any time. We may suspend or end access if you breach these Terms or if we
                change/discontinue the Service. We may update these Terms—if changes are significant, we’ll let you
                know. Continuing to use the Service means you accept the update.
              </p>
            </li>

            <li id="t9">
              <h2>Governing law</h2>
              <p>
                These Terms are governed by the laws of <strong>England and Wales</strong>, and disputes will be handled
                by the courts of England and Wales (unless a different mandatory law applies where you live).
              </p>
            </li>

            <li id="t10">
              <h2>Contact</h2>
              <p>Questions? We’re here to help.</p>
              <p>
                Email: <a href="mailto:hello@burst-athletics.com">james@burstathletics.co.uk</a>
                <br />
              </p>
            </li>
          </ol>
        </section>
      </main>

      <footer className="terms-footer">
        {/* <nav className="terms-links" aria-label="Footer">
          <a href="#terms-heading">Top</a>
          <a href="#t1">1</a>
          <a href="#t2">2</a>
          <a href="#t3">3</a>
          <a href="#t4">4</a>
          <a href="#t5">5</a>
          <a href="#t6">6</a>
          <a href="#t7">7</a>
          <a href="#t8">8</a>
          <a href="#t9">9</a>
          <a href="#t10">10</a>
        </nav> */}
        <div className="terms-copy">© {new Date().getFullYear()} Burst Athletics</div>
      </footer>
    </div>
  );
};

export default TermsPage;
